export const sortOptions = [
    { value: 'default', label: 'Portfolio % - By market' },
    { value: 'instrumentName_ASC', label: 'Security name - A to Z' },
    { value: 'instrumentName_DESC', label: 'Security name - Z to A' },
    { value: 'volume_DESC', label: 'Quantity - High to Low' },
    { value: 'volume_ASC', label: 'Quantity - Low to High' },
    { value: 'portfolioPercentage_DESC', label: 'Portfolio % - High to Low' },
    { value: 'portfolioPercentage_ASC', label: 'Portfolio % - Low to High' },
];

export const percentageIndicatorClass = (indicator) => {
    const classes = {
        [percentageIndicator.increase]: 'icon arrow-solid-head-green',
        [percentageIndicator.decrease]: 'icon arrow-solid-head-red arrow-down',
        [percentageIndicator.noChange]: 'icon dash',
    };

    const defaultIndicator = classes[percentageIndicator.noChange];

    return classes[indicator] || defaultIndicator;
};

export const percentageIndicator = {
    increase: 'increase',
    decrease: 'decrease',
    noChange: 'no-change',

    parse(value) {
        if (value > 0) {
            return this.increase;
        }

        if (value < 0) {
            return this.decrease;
        }

        return this.noChange;
    },
};
